<template>
  <div>
        <!--登录表单-->
        <h2 class="add-title">添加销售</h2>
        <!--当前企业-->
        <div class="current-store">
            <i class="el-icon-warning"></i>
            <span>当前企业：{{addUseItem.title}}</span>
        </div>
        <!--验证手机号-->
        <div class="steps-oen">
            <p>{{mobileExist>0?2:1}}</p>
            <div class="steps-oen-text">
                <h2 v-if="mobileExist==0">验证手机号</h2>
                <h2 v-else>{{mobileExist==1?'填写基本信息':'手机号已存在'}}</h2>
                <span v-if="mobileExist==0">请输入销售的手机号，系统将检测该手机号是否已注册</span>
                <span v-else>{{mobileExist==1?'该手机号未注册，请填写销售的基本信息':'可选择继续添加关联门店'}}</span>
            </div>    
        </div>
        <el-form :inline="true" :model="formData" :rules="rules" ref="formData" class="full-form" :hide-required-asterisk="true" label-width="80px">
            <el-form-item prop="mobile" label="手机号码">
                <el-input 
                v-model.trim="formData.mobile"  
                type="number"
                placeholder="请输入手机号码"
                clearable
                :style="{width: mobileExist==0?'78%':'100%'}"
                :disabled="mobileExist>0"
                />
                <!-- <el-button  type="primary" style="width: 18%; float: right;" @click="checkMobileExist('formData')"  block v-if="mobileExist==2">销售信息</el-button> -->
                <el-button  type="primary" style="width: 18%; float: right;" @click="checkMobileExist('formData')"  block v-if="mobileExist==0">检测</el-button>
            </el-form-item>
            <!--已存在销售信息-->
            <div class="steps-sales" v-if="mobileExist==2">
                <div class="truename"><i class="icon-geren1 iconfont"></i>{{ userInfo.truename }}<p class="phones">{{ userInfo.type==3?'销售':userInfo.level?'个人':'采购' }}</p></div>
                <ul class="steps-sales-list" >
                    <li v-if="storeList.length>0" class="related">关联门店</li>
                    <!-- <li><p>昵称</p><span>{{ userInfo.truename }}</span></li> -->
                    <li v-if="storeList.length>0">
                        <div class="d-flex flex-wrap steps-group">
                            <div v-for="item in storeList" :key="item.id">
                                {{ item.title }}
                                <span class="phones ml-2" v-if="item.position_name">{{ item.position_name }}</span>
                            </div>
                        </div>
                    </li>
                    <li v-else class="mb-2 nothing">
                       <i class="el-icon-warning"></i> 暂无关联门店
                    </li>
                </ul>
            </div>
            <template v-if=" mobileExist==1">
                <el-form-item prop="truename" label="姓　　名" style="width: 100%;">
                    <el-input v-model.trim="formData.truename"
                        type="text"
                        placeholder="请输入销售姓名"
                        clearable
                        />
                </el-form-item>
                <el-form-item prop="sex" label="性　　别">
                    <el-radio-group v-model="formData.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="2">女</el-radio>
                    </el-radio-group>
                </el-form-item>
            </template>
            <el-form-item prop="position_name" label="职　　位" v-if="mobileExist>0&&storeType==3">
                    <el-autocomplete
                    popper-class="my-autocomplete"
                    v-model="formData.position_name"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    @select="handleSelect"
                    style="width: 100%;"
                    >
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.name }}</div>
                    </template>
                    </el-autocomplete>
            </el-form-item>
                            <!-- <el-select v-model="formData.position_name" placeholder="请选择职位">
                    <el-option v-for="item in $GVAR.position" :key="item.id" :label="item.name" :value="item.name" ></el-option>
                </el-select> -->
            <p v-if="mobileExist==2&&storeType!=userInfo.type" class="remind">人员类型与当前职位不一致</p>
            <div class="d-flex justify-content-end mr-2" v-if="mobileExist>0">
                <el-button    @click="mobileExist=0"  block>返回</el-button>
                <el-button  type="primary"  @click="submitForm('formData')"  block :disabled="mobileExist==2?storeType!=userInfo.type:false">确认添加</el-button>
            </div>
        </el-form>
  </div>
</template>

<script>
import { mapState,mapGetters,mapActions} from 'vuex'
export default {
  name: 'AddPersonnel',
  components: {},
  props: {
    addUseItem: {
      type:Object,
      default:()=>{}
    },
    storeType: {
      type:String,
      default:'0'
    }
  },
  data() {
    return {
        formData:{
            store_id:'',
            store_type:'',
            truename:'',
            sex:'',
            mobile:'',
            position_name:'',
        },
        rules:{
            truename: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
            mobile: [{ validator: this.$verify.phoneNumber, trigger: 'blur' }],
            position_name: [
                { required: true, message: '请输入职位', trigger: 'blur' },
                {
                    validator: (rule, value, callback) => {
                    // 空值交给required校验处理
                    if (!value) return callback()
                    // 纯中文正则
                    const reg = /^[\u4e00-\u9fa5]+$/
                    if (!reg.test(value)) {
                        return callback(new Error('职位只能输入汉字，不可包含英文、数字、特殊符号'))
                    }
                    callback()
                    },
                    trigger: ['blur', 'change']
                },
                { max: 6, message: '输入职位不得大于6个汉字', trigger: 'blur' }
            ],
            sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        },
        mobileExist:0,  // 手机号是否已存在
        userInfo:{},  // 个人信息
        storeList:[],  // 门店列表
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
        
  },
  methods: {
    ...mapActions(['POST_Admin_AddUser','POST_Admin_CheckMobileExist','POST_Admin_AddSale','POST_Admin_GetUserInfoAndStoreList']),
        //检测手机号是否已存在
        async checkMobileExist(formName){
            await this.$refs[formName].validate(async valid => {
                if (valid) {
                    this.UserInfoAndStoreList();    
                    // this.POST_Admin_CheckMobileExist({data:{mobile:this.formData.mobile},successFun:(res)=>{
                    //     if (res.code === '00000') {
                    //         this.mobileExist = 1;
                    //     // 手机号已存在
                    //     } else if (res.code === '10088') {
                    //         // 获取个人信息和门店列表
                    //         this.UserInfoAndStoreList();
                    //     }
                    // }})
                } else {    
                    return false;
                }
            });
        },
        //获取个人信息
        UserInfoAndStoreList(){
            this.POST_Admin_GetUserInfoAndStoreList({data:{mobile:this.formData.mobile},
                successFun:(res)=>{
                    // 销售已存在
                    if(res.user_info.truename){
                        this.userInfo = res.user_info;
                        this.storeList = res.store_list;
                        this.mobileExist = 2;
                    }else{
                        this.mobileExist = 1;
                    }
                    console.log(res);

            }})
        },
        // 添加验证表单
        async submitForm(formName) {
            await this.$refs[formName].validate(async valid => {
                if (valid) {    
                    // 提交表单数据
                    this.formData.store_id = this.addUseItem.id;
                    this.formData.store_type = this.storeType;
                    //纯在则赋值uid
                    if(this.mobileExist==2){
                        this.formData.uid = this.userInfo.uid;
                    }
                    let POST=this.mobileExist==1?'POST_Admin_AddUser':'POST_Admin_AddSale';
                    this[POST]({data:this.formData,successFun:()=>{
                        // 提交成功后，清空表单数据
                        this.$refs[formName].resetFields();
                        this.$emit('addSuccess');
                         this.mobileExist = 0;
                    }})
                } else {    
                return false;
                }
            });
        },
        querySearch(queryString, cb) {
            var restaurants = this.$GVAR.position;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                // 兜底：不存在name直接返回false
                if (!restaurant || !restaurant.name) return false
                const name = restaurant.name.toLowerCase();
                const q = queryString.toLowerCase();
                return name.includes(q);
            };
        },
        handleSelect(item) {
            this.formData.position_name = item.name;
        },
    }
};
</script>

<style lang="scss" scoped>
    .full-form{
        display: flex;
        flex-direction: column; 
    }
    .add-title{
        margin-top: -40px;
        border-bottom: 1px solid #e4e7ed;
        width: 100%;
        padding:0 3%;
        margin-left: -3%;
        padding-bottom: 14px;
        font-size: 18px;
    }
    .current-store{
        background-color: var(--smtc-color-TextBackground-lightblue);
        width: 94%;
        padding: 10px 3%;
        margin-top: 14px;
        border-radius: 4px;
        color:var(--smtc-color-primary);
        font-weight: bold;
        i{
            font-size: 16px;
            margin-right: 5px;
        }
    }
    .steps-oen{
        display: flex;
        overflow: hidden;
        margin: 20px auto;
        width: 98%;
        >p{
            width: 23px;
            height: 23px;
            background-color: var(--smtc-color-primary);
            color: #fff;
            line-height: 24px;
            text-align: center;
            border-radius: 50%;
            margin-right: 14px;
            margin-top: 4px;
            justify-content:flex-end;
        }
        .steps-oen-text{
            
            h2{
                font-size: 20px;
            }
            span{
                font-size: 14px;
                color:#999;
                margin: 4px 0 6px 0;
                display: block;
            }
        }
    }
    .steps-sales{
        width: 86.5%;
        margin-left: 12.4%;
        color:var(--smtc-color-primary);
        font-weight: bold;
        margin-bottom: 15px;
        i{
            font-size: 16px;
            margin-right: 5px;
        }
    }
    .steps-sales-list{
        font-weight: normal;
        color:#333;
        padding: 10px 3% 0 3%;
        border-radius: 4px;
        background-color: var(--smtc-color-back);
        overflow: hidden;
        li{
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            p{
                color:#999;
                margin-right: 10px;
                font-size: 12px;
                margin-bottom: 5px;
            }
        }
    }
    .steps-group{
        width: 100%;
        div{
            display:block;
            width: 49%;
            font-size: 12px;
            margin-bottom: 5px;
        }
        >div:nth-child(2n){
            margin-left: 2%;
        }
    }
    .phones{
        font-weight: normal;
        margin-top: 12px;
        background-color: #fff;
        font-size: 11px;
        margin-top: 6px;
        padding: 4px 6px;
        border-radius: 4px;
        color: #999;
    }
    .truename{
        color:#333;
        margin-bottom: 10px;
        i{
            font-weight:normal;
        }
        .phones{
            background-color: var(--smtc-color-primary);
            color:#fff;
            display: inline-block;
            margin-left: 10px;
        }
    }
    .nothing{
        color: #999;
        font-size: 12px;
        display: flex;
        align-items: center;
    }
    .remind{
        text-align: right;
        font-size: 12px;
        color: var(--smtc-color-text-red);
        margin-right: 7px;
        margin-bottom: 6px;
    }
    .related{
        font-weight: bold;
        border-bottom: 1px solid #e4e7ed;
        padding-bottom: 6px;
    }
</style>

<style>
    .full-form .el-form-item__content{
        width: 87.5% !important;
    }
    .full-form .el-select{
        width: 100%;
    }
</style>
